import BaseModel from "./baseModel";

export default class Decorator extends BaseModel {
  object: object;

  constructor(obj: object = {}) {
    super();
    this.updateFrom(obj);
  }

  updateFrom(obj: object): this {
    this.object = obj;
    Object.assign(this, obj);
    return this;
  }
}